import { AlulaResponseData } from "@app/shared/databases/alula.database";
import { ClassImporterExporter, ImportMap } from "@app/shared/resources/class-importer-exporter.service";
import { ClareStatus } from "../../shared/model/clare-status.model";
import { AlulaReceiver } from "./alula-receiver";
import { AlulaReceiverBind } from "./alula-receiver-bind";

export interface AlulaReceiverGroup {
    id?: string;
    dealerId: string;
    name: string;
    description: string;
    dateModified?: string;
    dateEntered?: string;
    createdBy?: string;
    modifiedBy?: string;
}

export interface CentralStation {
    id?: string;
    dealerId: string;
    name: string;
    description?: string;
    receivers: AlulaReceiver[];
    binds: AlulaReceiverBind[];
    ipCommPath1?: string;
    ipCommPath1Status?: string | ClareStatus;
    ipCommPath2?: string;
    ipCommPath2Status?: string | ClareStatus;
    phoneCommPath?: string;
    phoneCommStatus?: ClareStatus;
    path1Protocol?: string;
    path2Protocol?: string;
}

interface AlulaReceiverGroupData extends AlulaReceiverGroup {}

export class AlulaReceiverGroupHelper {
    static dbEndpoint = "receivers/groups";
    static readonly importMap: ImportMap<AlulaReceiverGroup, AlulaReceiverGroupData> = [
        { i: "id", o: "id" },
        { i: "dealerId", o: "dealerId", skipExport: true },
        { i: "name", o: "name" },
        { i: "description", o: "description", skipExport: true },
        { i: "dateModified", o: "dateModified", skipExport: true },
        { i: "dateEntered", o: "dateEntered", skipExport: true },
        { i: "createdBy", o: "createdBy", skipExport: true },
        { i: "modifiedBy", o: "modifiedBy", skipExport: true },
    ];

    static fromDbObject(dbObject: AlulaResponseData): AlulaReceiverGroup {
        const obj = ClassImporterExporter.importObject(dbObject.attributes, this.importMap);
        obj.id = dbObject.id;
        return obj;
    }

    static toDbObject(obj: AlulaReceiverGroup): Partial<AlulaReceiverGroupData> {
        return ClassImporterExporter.exportObject(obj, this.importMap);
    }
}
